export function groupArrayByObjectKey<T extends Record<string, any>, K extends keyof T>(
  arr: T[],
  key: K,
  pushKey?: never
): Record<string, T[]>;

export function groupArrayByObjectKey<
  T extends Record<string, any>,
  K extends keyof T,
  P extends keyof T,
>(arr: T[], key: K, pushKey: P): Record<T[K], T[P][]>;

export function groupArrayByObjectKey<
  T extends Record<string, any>,
  K extends keyof T,
  P extends keyof T | undefined = undefined,
>(arr: T[], key: K, pushKey?: P): Record<T[K], P extends keyof T ? T[P][] : T[]> {
  return arr.reduce(
    (grouped, item) => {
      const groupKey = item[key];
      const value = pushKey ? item[pushKey] : item;
      (grouped[groupKey] = grouped[groupKey] || []).push(value as any);
      return grouped;
    },
    {} as Record<T[K], P extends keyof T ? T[P][] : T[]>
  );
}

export function groupObjectsArrayByKeySingle<T extends Record<string, any>, K extends keyof T>(
  arr: T[],
  keyField: K
): Record<T[K], T> {
  return Object.assign({}, ...arr.map((item) => ({ [item[keyField]]: item })));
}

export function range(start: number, stop: number, step: number): number[] {
  return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
}

export function createChunks<T>(inputArray: T[], perChunk: number): T[][] {
  const resultArray: T[][] = [];

  const chunkSize = Math.max(1, perChunk);

  for (let i = 0; i < inputArray.length; i += chunkSize) {
    resultArray.push(inputArray.slice(i, i + chunkSize));
  }

  return resultArray;
}

export const groupData = (data: any[], key: string) => {
  return data.reduce((acc, item) => {
    const propValue = item[key];

    if (!acc[propValue]) {
      acc[propValue] = item;
      return acc;
    }
    // Original function merges objects if they have same key but I'm not so sure if that's a good idea...
    // acc[propValue] = Object.assign(acc[propValue], item);

    return acc;
  }, {});
};
